export const DEMO_REP = "Arjun Mehta"

export const DEMO_LISTS = [
  {
    id: "priority-champions",
    name: "Priority champions",
    kind: "priority",
    people: [
      {
        id: 1001,
        name: "Sayan",
        title: "Tester contact",
        phone: "+917283930645",
        location_country: "IN",
        account: { id: "creative-planning", name: "Creative Planning" }
      },
      {
        id: 1004,
        name: "Chandra",
        title: "Tester contact",
        phone: "+916303990729",
        location_country: "IN",
        account: { id: "creative-planning", name: "Creative Planning" }
      },
      {
        id: 1007,
        name: "Madhu",
        title: "Tester contact",
        phone: "+917893711555",
        location_country: "IN",
        account: { id: "creative-planning", name: "Creative Planning" }
      },
      {
        id: 1008,
        name: "Giri",
        title: "Tester contact",
        phone: "+919022346716",
        location_country: "IN",
        account: { id: "creative-planning", name: "Creative Planning" }
      },
      {
        id: 1009,
        name: "Arpita",
        title: "Tester contact",
        phone: "+919538740410",
        location_country: "IN",
        account: { id: "creative-planning", name: "Creative Planning" }
      },
      {
        id: 1010,
        name: "Baudhik Malik",
        title: "Tester contact · Executor",
        phone: "+919413938475",
        location_country: "IN",
        account: { id: "creative-planning", name: "Creative Planning" }
      },
      {
        id: 1011,
        name: "Shalini",
        title: "Tester contact",
        phone: "+919513877404",
        location_country: "IN",
        account: { id: "creative-planning", name: "Creative Planning" }
      }
    ]
  }
]
